(function() {
    'use strict';

    angular
        .module('ipmApp')
        .controller('PsychIntakeController', PsychIntakeController);

        PsychIntakeController.$inject = ['$scope', '$state', '$timeout', '$translate', '$location', 'Auth', '$uibModal', '$window', 'psychIntake', 'ipmConstants'];

    function PsychIntakeController($scope, $state, $timeout, $translate, $location, Auth, $uibModal, $window, psychIntake, ipmConstants) {
        var vm = this;

        vm.psychIntake = psychIntake;
        vm.percent = 0;

        vm.init = function() {
            vm.percent = vm.getPercent();
        }

        vm.getLanguage = function() {
            return $translate.storage().get('NG_TRANSLATE_LANG_KEY');
        }

        vm.widthStyle = function() {
            vm.percent = vm.getPercent();
            if (vm.getPercent() > 0) {
                return { width: vm.getPercent() + '%' };
            } else {
                return { width: vm.getPercent() + '%', color: 'transparent' };
            }
        }

        vm.getPercent = function () {
        	if (vm.psychIntake.sectionIdsCompleted) {
                return Math.ceil((vm.psychIntake.sectionIdsCompleted.length / vm.psychIntake.totalSectionId) * 100);
            } else {
            	return 0;
            }
        }

        vm.init();
    }
})();
